import React from 'react';
import {
  FaWhatsapp,
  FaMapMarkerAlt,
  FaEnvelope,
  FaIndustry,
  FaHandshake
} from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function ContatoSection() {
  // ===== CONTATOS =====

  // VENDAS
  const vendasPhone = '(19) 99631-8018';
  const vendasWhatsapp = '5519996318018';
  const vendasLink = `https://wa.me/${vendasWhatsapp}?text=${encodeURIComponent(
    'Olá Usina Rosa, gostaria de informações comerciais e de vendas.'
  )}`;

  // COMPRAS
  const comprasPhone = '(15) 99170-6314';
  const comprasWhatsapp = '5515991706314';
  const comprasLink = `https://wa.me/${comprasWhatsapp}?text=${encodeURIComponent(
    'Olá Usina Rosa, gostaria de tratar assuntos relacionados a compras.'
  )}`;

  const endereco = 'Rod. Castelo Branco, Km 111 — Pinhal, Boituva - SP';
  const email = 'comercial@rosaindustria.com';

  // ===== ANIMAÇÃO =====
  const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.1 * i,
        duration: 0.5,
        ease: 'easeOut'
      }
    })
  };

  return (
    <section className="relative py-24 px-6">
      {/* BACKGROUND */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white via-emerald-50/70 to-white" />

      {/* HEADER */}
      <div className="max-w-5xl mx-auto text-center">
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-4xl md:text-5xl font-extrabold text-emerald-900"
        >
          Entre em Contato
        </motion.h2>

        <motion.p
          custom={1}
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="mt-4 text-lg text-slate-600 max-w-3xl mx-auto"
        >
          Para agilizar o atendimento, escolha o canal de acordo com o seu perfil.
        </motion.p>
      </div>

      {/* GRID PRINCIPAL */}
      <div className="max-w-6xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* ===== VENDAS ===== */}
        <motion.div
          custom={2}
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="relative rounded-3xl border border-emerald-200 bg-white p-8 shadow-lg"
        >
          <span className="absolute top-6 right-6 text-xs font-bold bg-emerald-100 text-emerald-800 px-4 py-1 rounded-full">
            CLIENTES
          </span>

          <div className="flex items-center gap-4">
            <div className="bg-emerald-600 text-white p-4 rounded-2xl">
              <FaIndustry className="text-2xl" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-emerald-900">
                Comercial / Vendas
              </h3>
              <p className="text-slate-600">
                Para compra de produtos e informações comerciais
              </p>
            </div>
          </div>

          <ul className="mt-6 space-y-2 text-slate-700">
            <li>• Etanol e derivados</li>
            <li>• Condições comerciais</li>
            <li>• Volumes, contratos e logística</li>
          </ul>

          <div className="mt-6 text-slate-800 font-semibold">
            📞 {vendasPhone}
          </div>

          <a
            href={vendasLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center justify-center gap-3 w-full rounded-xl bg-emerald-600 px-6 py-4 text-white text-lg font-bold hover:bg-emerald-700 transition"
          >
            <FaWhatsapp className="text-xl" />
            Falar com Vendas
          </a>
        </motion.div>

        {/* ===== COMPRAS ===== */}
        <motion.div
          custom={3}
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="relative rounded-3xl border border-sky-200 bg-white p-8 shadow-lg"
        >
          <span className="absolute top-6 right-6 text-xs font-bold bg-sky-100 text-sky-800 px-4 py-1 rounded-full">
            FORNECEDORES
          </span>

          <div className="flex items-center gap-4">
            <div className="bg-sky-600 text-white p-4 rounded-2xl">
              <FaHandshake className="text-2xl" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-sky-900">Compras</h3>
              <p className="text-slate-600">
                Para fornecedores e propostas comerciais
              </p>
            </div>
          </div>

          <ul className="mt-6 space-y-2 text-slate-700">
            <li>• Matéria-prima e insumos</li>
            <li>• Equipamentos e manutenção</li>
            <li>• Serviços e parcerias</li>
          </ul>

          <div className="mt-6 text-slate-800 font-semibold">
            📞 {comprasPhone}
          </div>

          <a
            href={comprasLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center justify-center gap-3 w-full rounded-xl bg-sky-600 px-6 py-4 text-white text-lg font-bold hover:bg-sky-700 transition"
          >
            <FaWhatsapp className="text-xl" />
            Falar com Compras
          </a>
        </motion.div>
      </div>

      {/* INFO SECUNDÁRIA */}
      <div className="max-w-6xl mx-auto mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* ENDEREÇO */}
        <div className="rounded-2xl border bg-white p-6 shadow-sm flex items-start gap-4">
          <div className="bg-emerald-100 text-emerald-700 p-3 rounded-xl">
            <FaMapMarkerAlt className="text-xl" />
          </div>
          <div>
            <h4 className="font-semibold text-emerald-900">Endereço</h4>
            <p className="text-slate-600 mt-1">{endereco}</p>
          </div>
        </div>

        {/* EMAIL */}
        <div className="rounded-2xl border bg-white p-6 shadow-sm flex items-start gap-4">
          <div className="bg-emerald-100 text-emerald-700 p-3 rounded-xl">
            <FaEnvelope className="text-xl" />
          </div>
          <div>
            <h4 className="font-semibold text-emerald-900">E-mail</h4>
            <p className="mt-1 font-medium text-slate-800 break-all">
              {email}
            </p>
            <p className="mt-1 text-sm text-slate-600">
            Canal destinado a <strong>demais assuntos</strong>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}